<template>
  <span
    class="thinking-dots"
    :style="{
      '--dot-size': size + 'px',
      '--dot-gap': Math.max(2, Math.round(size * 0.6)) + 'px',
    }"
    aria-label="Working"
    role="status"
  >
    <span class="thinking-dots__dot" />
    <span class="thinking-dots__dot" />
    <span class="thinking-dots__dot" />
  </span>
</template>

<script>
export default {
  name: "ThinkingDots",
  props: {
    size: { type: Number, default: 6 },
  },
};
</script>

<style scoped>
.thinking-dots {
  display: inline-flex;
  align-items: center;
  gap: var(--dot-gap);
  line-height: 0;
  vertical-align: middle;
}
.thinking-dots__dot {
  display: inline-block;
  width: var(--dot-size);
  height: var(--dot-size);
  border-radius: 50%;
  background: currentColor;
  opacity: 0.25;
  animation: thinking-dots-pulse 1.2s infinite ease-in-out;
}
.thinking-dots__dot:nth-child(2) {
  animation-delay: 0.15s;
}
.thinking-dots__dot:nth-child(3) {
  animation-delay: 0.3s;
}
@keyframes thinking-dots-pulse {
  0%,
  80%,
  100% {
    opacity: 0.25;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .thinking-dots__dot {
    animation: thinking-dots-fade 1.4s infinite ease-in-out;
    transform: none !important;
  }
  @keyframes thinking-dots-fade {
    0%,
    100% {
      opacity: 0.4;
    }
    50% {
      opacity: 1;
    }
  }
}
</style>
